import type { OrganizationPresentation } from "../../../../../api/public/presentation"

export type OrgPresentationMode =
  | "appointment_portal_only"
  | "appointment_portal_with_bot"
  | "bot_only"

const CHAT_PLAN_FAMILIES = new Set(["kehrchat", "kehrtalk"])
const BASE_PLAN_FAMILIES = new Set(["kehrbase"])

const normalize = (value: string | null | undefined): string | null => {
  const text = (value ?? "").trim().toLowerCase()

  return text || null
}

export const supportsTerminbot = (
  organization: OrganizationPresentation | null | undefined,
): boolean => {
  if (!organization) return false

  const planFamilyId = normalize(organization.plan_family_id)

  if (planFamilyId) {
    if (CHAT_PLAN_FAMILIES.has(planFamilyId)) return true

    if (BASE_PLAN_FAMILIES.has(planFamilyId)) return false
  }

  const legacyTier = normalize(organization.tier)

  if (!legacyTier) return true

  return !BASE_PLAN_FAMILIES.has(legacyTier) && legacyTier !== "free_trial"
}

export const resolveOrgPresentationMode = (
  organization: OrganizationPresentation | null | undefined,
  _contactStepCode: string | null | undefined,
): OrgPresentationMode => {
  if (!supportsTerminbot(organization)) {
    return "appointment_portal_only"
  }

  return "appointment_portal_with_bot"
}

export const presentationModeUsesTerminbot = (mode: OrgPresentationMode): boolean =>
  mode === "appointment_portal_with_bot" || mode === "bot_only"

export const presentationModeUsesAppointmentPortal = (mode: OrgPresentationMode): boolean =>
  mode === "appointment_portal_with_bot" || mode === "appointment_portal_only"
